import { useEffect, useCallback, useMemo } from "react";
import { Outlet, useLocation, useNavigate, NavLink } from "react-router-dom";
import { Tabs } from "@/components";

const Billing = () => {
  const location = useLocation();
  const navigate = useNavigate();

  // Redirect to pricing if on "/billing"
  const handleRedirect = useCallback(() => {
    if (location.pathname === "/billing") {
      navigate("/billing/codRemittance", { replace: true });
    }
  }, [location.pathname, navigate]);

  useEffect(() => {
    handleRedirect();
  }, [handleRedirect]);

  // Memoized tabs array
  const tabs = useMemo(
    () => [
      { label: "COD Remittance", link: "codRemittance" },
      { label: "Weight Dispute", link: "weightDispute" },
      { label: "Wallet Transaction", link: "walletTransaction" },
      { label: "Invoice", link: "invoice" },
      { label: "Credit Note", link: "creditNote" },
    ],
    []
  );

  return (
    <div className="w-full flex-1 flex flex-col pb-20 md:pb-4 relative max-w-[2000px]">
      <Tabs tabs={tabs} NavLink={NavLink  } />
      <Outlet />
    </div>
  );
};

export default Billing;
